import React from "react";
import {
  HStack,
  VStack,
  Avatar,
  AvatarGroup,
  Text,
  Center,
  Box,
  Heading,
  Stack,
} from "@chakra-ui/react";
import { Link } from "gatsby";
import { IoPeople } from "react-icons/io5";
import { TbDatabaseHeart } from "react-icons/tb";
import { shuffle } from "lodash";

import Paragraph from "../ui/common/Paragraph";
// import Profile from "../ui/common/Profile";

const imageDir = "/static/images";

const curators = [
  {
    photo: "chris-grove.jpg",
    name: "Chris Grove",
    position: "Curator",
    species: "WormBase",
    affiliation: "California Institute of Technology, Pasadena, CA USA",
  },
  {
    photo: "stavros-diamantakis.jpg",
    name: "Stavros Diamantakis",
    position: "Curator",
    species: "WormBase",
    affiliation: "EMBL-EBI, Hinxton, Cambridge, England, United Kingdom",
  },
  {
    photo: "raymond-lee.jpg",
    name: "Raymond Lee",
    position: "Curator",
    species: "WormBase",
    affiliation: "California Institute of Technology, Pasadena, CA USA",
  },
  {
    photo: "ranjana-kishore.jpg",
    name: "Ranjana Kishore",
    position: "Curator",
    species: "WormBase",
    affiliation: "California Institute of Technology, Pasadena, CA USA",
  },
  {
    photo: "rex-nelson.jpg",
    name: "Rex Nelson",
    position: "Curator",
    species: "Soybase",
    affiliation: "USDA-ARS",
  },
  {
    photo: "naomi-stover.jpg",
    name: "Naomi Stover",
    position: "Curator",
    species: "Tetrahymena Genome Database",
    affiliation: "Bradley University, Peoria, IL USA",
  },
  {
    photo: "valerie-wood.jpg",
    name: "Valerie Wood",
    position: "Curator",
    species: "PomBase",
    affiliation: "University of Cambridge, Cambridge, UK",
  },
  {
    photo: "pascal-carme.png",
    name: "Pascal Carme",
    position: "Curator",
    species: "PomBase",
    affiliation: "University College London, London, UK",
  },
  {
    // photo: ".jpg",
    name: "Constance Smith",
    position: "Curator",
    species: "Mouse Genome Informatics",
    affiliation: "The Jackson Laboratory, Bar Harbor, ME USA",
  },
  {
    photo: "jing-yu.jpg",
    name: "Jing Yu",
    position: "Curator",
    species: "CottonGen",
    affiliation: "Washington State University, WA USA",
  },
  {
    // photo: "shur-jen-wang.jpg",
    name: "Shur-Jen Wang",
    position: "Curator",
    species: "Rat Genome Database",
    affiliation: "Medical College of Wisconsin Milwaukee, WI USA",
  },
  {
    photo: "holly-paddock.png",
    name: "Holly Paddock",
    position: "Curator",
    species: "ZFIN",
    affiliation: "University of Oregon, Eugene, OR, USA",
  },
];

const CuratorialSection = (props) => {
  const { numCurators, numActivities } = props;

  return (
    <>
      <Center>
        <Stack maxWidth="7xl" paddingTop="50px" marginBottom="1em">
          <Heading size="lg" color="gray" marginBottom="1em" align="center">
            Curatorial Activities
          </Heading>
          <Box
            maxWidth="7xl"
            borderWidth="1px"
            borderRadius="lg"
            p="10vh"
            fontFamily="Noto sans, sans-serif"
            marginBottom="1em"
          >
            <Heading size="md">
              Curatorial Activities: working with community knowledgebases to
              streamline data curation into databases
            </Heading>
            <>
              {" "}
              <Paragraph>
                <i>microPublication</i> works directly with knowledgebase
                curators to ensure submitted data meet community standards.
                After a manuscript has been accepted for publication, a{" "}
                <i>Third Party Review</i> step sends the article to a willing
                database biocurator. During this step, biocurators perform{" "}
                <i>Pre-publication FAIR Curation</i>, which is a quality control
                step ensuring that the entities reported are represented
                correctly and follow community standards, and that the reported
                experiment has enough information to be curated in their
                database. If biocurators find anything that does not meet
                community standards, the author is requested to make corrections
                before publication, a biological copyediting task, if you will.{" "}
                <i>Database Curation</i> is an additional aspect of this step;
                biocurators can directly annotate the newly reported data into
                their databases, speeding the process of getting their data to
                the public.
              </Paragraph>
              <Paragraph>
                <i>microPublication</i> uses APICURON (
                <Link href="https://apicuron.org/databases/micropub" isExternal>
                  <u>https://apicuron.org/databases/micropub</u>
                </Link>
                ) to track and credit the work and effort of biocurators, such
                as quality control, validation, and data annotation. Should be
                Biocurators can choose to be formally recognized and recorded in
                an open, standardized framework, and you can see their
                contributions, logged in real time, both on the APICURON site
                and below.
              </Paragraph>
              <Paragraph>
                APICURON links biocuration activities to ORCID iDs of the
                contributor (with consent), allowing biocurators to build a
                verifiable record of their work. Apicuron integration supports
                our ongoing efforts to promote transparency, encourage expert
                participation, and highlight the value of curation in scientific
                publishing. Please note that, since APICURON needs curator
                consent to display data, the number of contributions listed
                below may differ from the APICURON website.
              </Paragraph>
              <HStack>
                <HStack
                  width="xs"
                  borderWidth="1px"
                  borderRadius="lg"
                  fontFamily="Noto sans, sans-serif"
                  padding="20px"
                >
                  <Avatar icon={<IoPeople />} color="purple" />
                  <VStack>
                    <Text as="b">{numCurators}</Text>
                    <Text>Curators</Text>
                  </VStack>
                </HStack>
                <HStack
                  width="xs"
                  borderWidth="1px"
                  borderRadius="lg"
                  fontFamily="Noto sans, sans-serif"
                  padding="20px"
                >
                  <Avatar icon={<TbDatabaseHeart />} color="purple" />
                  <VStack>
                    <Text as="b">{numActivities}</Text>
                    <Text>Curatorial Activities</Text>
                  </VStack>
                </HStack>
              </HStack>
              <Paragraph>
                <Text as="b">Curatorial Activities</Text>
                <br />
                <Text as="b">Pre-publication FAIR curation:</Text> quality
                control to ensure authors follow community standards when
                reporting entities
                <br />
                <Text as="b">Database curation:</Text> annotate the newly
                reported data into their databases
              </Paragraph>
            </>
          </Box>
          <Link to="/about/editorial-policies/editorial-board-and-staff">
            <Box
              maxWidth="7xl"
              borderWidth="1px"
              borderRadius="lg"
              p="5vh"
              fontFamily="Noto sans, sans-serif"
              marginBottom="1em"
            >
              <Center>
                <Stack>
                  <AvatarGroup>
                    {shuffle(curators)
                      .filter((person) => person.photo)
                      .slice(0, 4)
                      .map((person) => (
                        <Avatar
                          name={person.name}
                          size="2xl"
                          src={`${imageDir}/${person.photo}`}
                        />
                      ))}
                  </AvatarGroup>
                  <Heading size="md" align="center">
                    Meet our Editorial and Curatorial Team
                  </Heading>
                </Stack>
              </Center>
            </Box>
          </Link>
        </Stack>
      </Center>
    </>
  );
};

export default CuratorialSection;
